import { ReviewStep } from '../components/ReviewStep';
import { InvestmentCompletedStep } from '../components/InvestmentCompletedStep';
import { SelectStep } from '../components/SelectStep';
import { InvestmentStep } from '../components/InvestmentStep';

export enum EProductInvestmentSteps {
  SELECTION,
  INVESTMENT,
  REVIEW,
  CONCLUSION
}

export const ProductInvestmentComponents = {
  [EProductInvestmentSteps.SELECTION]: SelectStep,
  [EProductInvestmentSteps.INVESTMENT]: InvestmentStep,
  [EProductInvestmentSteps.REVIEW]: ReviewStep,
  [EProductInvestmentSteps.CONCLUSION]: InvestmentCompletedStep
};
